const invoices = {
  invoices: [
    {
      id: 10,
      name: "Book Digital",
      link: "/pedidos/book",
      icon: "mdi-cart-outline",
      color: "",
    },
    {
      id: 1,
      name: "Emissão de Pedidos",
      link: "/pedidos/cadastro/emissao-pedido",
      icon: "mdi-file-document-outline",
      color: "",
    },
    {
      id: 20,
      name: "Situação dos Pedidos <br /> Franqueadora",
      link: "/pedidos/franqueadora/listar",
      icon: "mdi-file-document-outline",
      color: "",
    },
    {
      id: 2,
      name: "Promoções",
      link: "/pedidos/promocoes",
      icon: "mdi-file-document-outline",
      color: "",
    },
    {
      id: 3,
      name: "Pedidos em Manutenção <br /> (Pendentes)",
      link: "/pedidos/cadastro/pedidos-manutencao",
      icon: "mdi-file-document-outline",
      color: "",
    },
    {
      id: 4,
      name: "Consulta de Pedidos",
      link: "/pedidos/consulta-pedido",
      icon: "mdi-file-document-outline",
      color: "",
    },
    {
      id: 5,
      name: "Duplicar Pedidos",
      link: "/pedidos/cadastro/duplicar-pedido",
      icon: "mdi-file-document-outline",
      color: "",
    },
    {
      id: 6,
      name: "Transferir Pedidos",
      link: "/pedidos/cadastro/transferir-pedido",
      icon: "mdi-file-document-outline",
      color: "",
    },
    {
      id: 7,
      name: "Histórico <br> Transferência Pedidos",
      link: "/pedidos/historico-transferencia",
      icon: "mdi-file-document-outline",
      color: "",
    },
    {
      id: 8,
      name: "Reabrir Pedidos <br /> Cancelados",
      link: "/pedidos/cadastro/reabrir-pedido",
      icon: "mdi-file-document-outline",
      color: "red",
    },
  ],
  settings: [
    {
      id: 1,
      name: "Condição de Pagamento",
      link: "/condicao-pagamento",
      icon: "mdi-cash-multiple",
      color: "",
    },
    {
      id: 2,
      name: "Condição de Pagamento <br /> por Fornecedor",
      link: "/pedidos/configuracao/condicao-pagto",
      icon: "mdi-application-cog",
      color: "",
    },
    {
      id: 3,
      name: "Condição de Pagamento <br /> Especial - Franquias",
      link: "/pedidos/configuracao/especial-franquias",
      icon: "mdi-application-cog",
      color: "",
    },
    {
      id: 4,
      name: "Oportunidade Fornecedor",
      link: "/pedidos/configuracao/promocoes",
      icon: "mdi-application-cog",
      color: "",
    },
    {
      id: 5,
      name: "Frete por Fornecedor",
      link: "/pedidos/configuracao/frete",
      icon: "mdi-application-cog",
      color: "",
    },
    {
      id: 6,
      name: "Observação Pedido",
      link: "/pedidos/configuracao/pedido/observacao",
      icon: "mdi-application-cog",
      color: "",
    },
    {
      id: 30,
      name: "Estimativa de Faturamento <br /> Fornecedor",
      link: "/pedidos/cadastro/estimativa-faturamento",
      icon: "mdi-file-document-outline",
      color: "",
    },
  ],
};
const royalties = {
  registers: [
    {
      id: 1,
      name: "Acordos e Percentuais <br />de Royalties",
      link: "/royalties/cadastro/acordo-percentuais",
      icon: "mdi-file-document-outline",
      color: "",
    },
    {
      id: 2,
      name: "Registro de Eventos",
      link: "/royalties/cadastro/registro-eventos",
      icon: "mdi-file-document-outline",
      color: "",
    },
    {
      id: 3,
      name: "Inserção Indicadores <br />de Desempenho",
      link: "/royalties/cadastro/indicadores-desempenho",
      icon: "mdi-file-document-outline",
      color: "",
    },
    {
      id: 4,
      name: "Tipo de Lançamento <br/>da Fatura",
      link: "/royalties/cadastro/tipos-lancamento",
      icon: "mdi-file-document-outline",
      color: "",
    },
    {
      id: 5,
      name: "Motivo Cancelamento <br/>Reembolso",
      link: "/royalties/cadastro/motivo-cancelamento-reembolso",
      icon: "mdi-file-document-outline",
      color: "",
    },
    {
      id: 6,
      name: "Motivo Cancelamento <br/>Royalties",
      link: "/royalties/cadastro/motivo-cancelamento-royalties",
      icon: "mdi-file-document-outline",
      color: "",
    },
    // {
    //   id: 20,
    //   name: "Cadastro Notas Fiscais <br />para Conciliação",
    //   link: "/royalties/cadastro/notas-fiscais",
    //   icon: "mdi-file-document-outline",
    //   color: "red",
    // },
    {
      id: 7,
      name: "Conciliação Pedido x <br />Nota Fiscal",
      link: "/royalties/cadastro/conciliacao-pedido",
      icon: "mdi-file-document-outline",
      color: "",
    },
    {
      id: 8,
      name: "Edição de Notas <br />Conciliadas",
      link: "/royalties/cadastro/edicao-notas-conciliadas",
      icon: "mdi-file-document-outline",
      color: "",
    },
    // {
    //   id: 9,
    //   name: "Auditoria de Pedidos",
    //   link: "/royalties/cadastro/auditoria-pedidos",
    //   icon: "mdi-file-document-outline",
    //   color: "yellow",
    // },
  ],
  royalties: [
    {
      id: 40,
      name: "Inserção de Lançamentos <br /> por Arquivo",
      link: "/royalties/lancamentos",
      icon: "mdi-file",
      color: "",
    },
    {
      id: 1,
      name: "Emissão Fatura de <br />Royalties Individual",
      link: "/royalties/emissao/fatura-individual",
      icon: "mdi-currency-usd",
      color: "",
    },
    {
      id: 2,
      name: "Emissão Fatura de <br />Royalties Grupo",
      link: "/royalties/emissao/fatura-grupo",
      icon: "mdi-currency-usd",
      color: "",
    },
    {
      id: 3,
      name: "Cancelamento Fatura <br />Royalties Individual",
      link: "/royalties/cancelamento/fatura-individual",
      icon: "mdi-currency-usd",
      color: "",
    },
    {
      id: 4,
      name: "Cancelamento Fatura <br />Royalties Grupo",
      link: "/royalties/cancelamento/fatura-grupo",
      icon: "mdi-currency-usd",
      color: "",
    },
    {
      id: 5,
      name: "Impressão Fatura <br />Royalties Individual",
      link: "/royalties/impressao/fatura-individual",
      icon: "mdi-currency-usd",
      color: "",
    },
    {
      id: 6,
      name: "Emissão Fatura <br />Reembolso",
      link: "/royalties/reembolso/emissao",
      icon: "mdi-currency-usd",
      color: "",
    },
    {
      id: 7,
      name: "Cancelamento Fatura <br />Reembolso",
      link: "/royalties/reembolso/cancelamento",
      icon: "mdi-currency-usd",
      color: "",
    },
    {
      id: 8,
      name: "Impressão Fatura <br />Reembolso",
      link: "/royalties/reembolso/impressao",
      icon: "mdi-currency-usd",
      color: "",
    },
    {
      id: 41,
      name: "Download de Arquivos",
      link: "/royalties/publicacao/faturas",
      icon: "mdi-file",
      color: "",
    },
    {
      id: 42,
      name: "Contas a Receber",
      link: "/royalties/publicacao/contas-receber",
      icon: "mdi-file",
      color: "",
    },
  ],
  publishes: [
    {
      id: 1,
      name: "Publicação de Relatórios",
      link: "/royalties/publicacao/publicacao-relatorios",
      icon: "mdi-publish",
      color: "yellow",
    },
    {
      id: 2,
      name: "Relação de Documentos <br />por Franqueado",
      link: "/royalties/publicacao/relacao-documentos",
      icon: "mdi-publish",
      color: "yellow",
    },
    {
      id: 3,
      name: "Publicação e Envio <br />de Faturas",
      link: "/royalties/publicacao/faturas",
      icon: "mdi-publish",
      color: "yellow",
    },
  ],
  reports: [
    {
      id: 0,
      name: "Relatório de Faturas de <br />Reembolso Canceladas",
      link: "/royalties/relatorios/notas-reembolso-canceladas",
      icon: "mdi-file-chart-outline",
      color: "",
    },
    {
      id: 1,
      name: "Notas Conciliadas",
      link: "/royalties/relatorios/notas-conciliadas",
      icon: "mdi-file-chart-outline",
      color: "",
    },
    // {
    //   id: 2,
    //   name: "Notas Conciliadas <br />por Período (Fornecedor)",
    //   link: "/royalties/relatorios/notas-conciliadas-periodo",
    //   icon: "mdi-file-chart-outline",
    //   color: "red",
    // },
    // {
    //   id: 3,
    //   name: "Contas a Receber <br />por Franqueado",
    //   link: "/royalties/relatorios/contas-receber-franqueado",
    //   icon: "mdi-file-chart-outline",
    //   color: "red",
    // },
    // {
    //   id: 4,
    //   name: "Situação de Pedidos <br />por Fornecedor",
    //   link: "/royalties/relatorios/situacao-pedido-fornecedor",
    //   icon: "mdi-file-chart-outline",
    //   color: "red",
    // },
    {
      id: 5,
      name: "Relatório Comparativo <br />de Produtos x Pares",
      link: "/roylaties/relatorios/comparativo-produtos",
      icon: "mdi-file-chart-outline",
      color: "",
    },
    {
      id: 6,
      name: "Relatório Ranking <br />de variação de Franquias",
      link: "/royalties/relatorios/ranking-variacao-franquias",
      icon: "mdi-file-chart-outline",
      color: "",
    },
    {
      id: 9,
      name: "Relatório / Publicação <br /> Ranking de Franquias",
      link: "/royalties/relatorios/ranking-franquias",
      icon: "mdi-file-chart-outline",
      color: "",
    },
    {
      id: 7,
      name: "Relatório Faturamento <br />Mensal da Rede",
      link: "/royalties/relatorios/faturamento-mensal-rede",
      icon: "mdi-file-chart-outline",
      color: "",
    },
    {
      id: 8,
      name: "Relatório Faturamento <br />Mensal por Franqueado",
      link: "/royalties/relatorios/faturamento-mensal-franqueado",
      icon: "mdi-file-chart-outline",
      color: "",
    },
  ],
};
const express = {
  itens: [
    {
      id: 1,
      name: "Tipo de Ajustes",
      link: "/express/ajustes",
      icon: "mdi-file",
      color: "",
    },
    {
      id: 2,
      name: "Cadastro de Grade Padrão",
      link: "/express/grade-padrao",
      icon: "mdi-file",
      color: "",
    },
    {
      id: 3,
      name: "Manutenção de Preços",
      link: "/express/manutencao-preco",
      icon: "mdi-file",
      color: "",
    },
    {
      id: 4,
      name: "Ajuste no Estoque",
      link: "/express/lancamento-estoque",
      icon: "mdi-file",
      color: "",
    },
    {
      id: 11,
      name: "Aprovar Ajuste Estoque",
      link: "/express/aprovar-lancamento",
      icon: "mdi-file",
      color: "",
    },
    {
      id: 5,
      name: "Emissão de Pedido Express",
      link: "/express/pedido",
      icon: "mdi-cart-outline",
      color: "yellow",
    },
    {
      id: 6,
      name: "Banner Promoção <br />Pedido Express",
      link: "/express/banner",
      icon: "mdi-message-alert",
      color: "",
    },
  ],
};

export { invoices, royalties, express };
